<template>
    <el-card style="height: 99%" :body-style="{ height: '100%' }" class="mead-bike-map">
        <template #header>
            <content-header />
        </template>
        <el-row type="flex" style="height: 100%">
            <div class="amap-page-container">
                <!-- <el-amap-search-box class="search-box" :search-option="searchOption" -->
                    <!-- :on-search-result="onSearchResult" /> -->
                <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center" :default-cursor="defaultCursor"
                    :zoom="zoom" :amap-manager="amapManager" :events="events">

                    <!-- <el-amap-marker
                        :position="marker.position"
                        :events="marker.events"
                        :visible="marker.visible"
                        :draggable="marker.draggable"
                        :icon="marker.icon"
                    /> -->
                    <el-amap-polygon v-for="(polygon, index) in polygons" :key="index" :vid="index" :editable="false"
                        :ref="`polygon_show_${index}`" :path="polygon.path" :draggable="polygon.draggable"
                        :fill-opacity="polygon.fillOpacity" :stroke-color="polygon.strokeColor"
                        :stroke-style="polygon.strokeStyle" :fill-color="polygon.fillColor" />

                    <el-amap-polygon :key="form.id" :vid="form.id" :editable="true" :ref="`polygon_${form.id}`"
                        :fill-opacity="polygon.fillOpacity" :stroke-color="polygon.strokeColor" :path="polygon.path"
                        :draggable="polygon.draggable" :events="polygon.events" />

                    <el-button-group class="info">
                        <!-- <el-button type="primary" :disabled="addFenceDisabled" @click="addFence">绘制骑行区域</el-button> -->
                        <!-- <el-button
                            type="primary"
                            :disabled="addFuSheFenceDisabled"
                            @click="addFusheFence"
                            >绘制辐射区域
                        </el-button>
                        <el-button type="primary" @click="removeFence"
                            >清除围栏</el-button
                        > -->
                    </el-button-group>
                </el-amap>
            </div>
            <div class="form-class">
                <lz-form ref="form" :submit="onSubmit" :errors.sync="errors" :form.sync="form" :edit-mode="editMode"
                    :rules="rules" :disable-redirect="true" label-width="35%" style="width: 100%">
                    <el-form-item label="区域名称" required prop="name">
                        <el-input v-model="form.name" class="limitwidth" />
                    </el-form-item>
                    <el-form-item label="区域类型" required prop="type">
                        <el-select filterable clearable v-model="form.type" placeholder="请选择" class="limitwidth">
                            <el-option key="1" label="禁停区" value="1" />
                            <el-option key="2" label="停车区" value="2" />
                            <el-option key="3" label="运维分区" value="3" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="停车上限" v-show="show_max_number" prop="max_number">
                        <el-input v-model="form.max_number" class="limitwidth"
                            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" />
                    </el-form-item>
                    <el-form-item label="区域状态" required prop="status">
                        <el-switch style="display: block" v-model="form.status" active-color="#13ce66"
                            inactive-color="#ff4949" active-text="正常" inactive-text="禁用" />
                    </el-form-item>
                    <el-form-item label="围栏区域" prop="parking_fence">
                        <el-input type="textarea" class="limitwidth" required v-model="form.parking_fence" disabled />
                        <div style="color: #ccc;">{{ polygon.path.length }}个点</div>
                    </el-form-item>
                </lz-form>

                <div style="padding: 10px;">
                    <p>切换分区：</p>
                    <el-tag :class="{ 'gary': (row.id == form.id),'success':1}"
                        style="margin: 5px 5px 5px 0;cursor: pointer;" v-for="(row, key) in parkings" :key="key"
                        @click="handleChange(row, key)">{{ row.name
                        }}</el-tag>
                </div>
            </div>
        </el-row>
    </el-card>
</template>

<script>
import VueAMap from "vue-amap";
import LzForm from "@c/LzForm";
import { updateParkingFence, getParking, getParkings } from '@/api/parking'
import FormHelper from "@c/LzForm/FormHelper";

export default {
    name: "Form",
    components: {
        LzForm,
    },
    mixins: [FormHelper],
    data() {
        let self = this;
        let amapManager = new VueAMap.AMapManager();
       
        return {
            form: {
                id: 0,
                type: '2',
                area_id: '',
                name: '',
                max_number: 0,
                parking_fence: [],
                form_fence: '',
                status: true,
            },
            rules: {
               
            },
            errors: {},
            center: [121.59996, 31.197646],
            searchOption: {
                city: "郑州",
                citylimit: false,
            },
            defaultCursor: "pointer",
            zoom: 12,
            lng: 0,
            lat: 0,
            loaded: false,
            amapManager: amapManager,
            polygon:  {
                draggable: false,
                path: [],
                fillOpacity: 0.1,
                events: {
                    click: () => {

                    },
                },
            },
            parkings:[],
            polygons:[],
            marker: {
                position: [121.5273285, 31.21515044],
                events: {
                    click: () => {
                        // alert('click marker')
                    },
                    dragend: (e) => {
                        console.log("---event---: dragend");
                        this.markers[0].position = [
                            e.lnglat.lng,
                            e.lnglat.lat,
                        ];
                    },
                },
                visible: true,
                draggable: false,
                template: "<span>1</span>",
            },
            events: {
                init(o) {},
            },
            mouseTool: null,
            mouseToolFushe: null,
            plugin: [
                {
                    pName: "Geolocation",
                    events: {
                        init(o) {
                            // o 是高德地图定位插件实例
                            // console.log(o)
                        },
                    },
                },
                {
                    pName: "Scale",
                    // offset: { x: 20, y: 20 },
                    position: "RB",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
                {
                    pName: "ToolBar",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
            ],
            addFenceDisabled: false,
            addFuSheFenceDisabled: false,
        };
    },
    created() {
        let query = this.$route.query;;
        this.getParing(query.id)
    },
    methods: {
        handleClickLink(row) {
            this.$router.push({
                path: '/parking/edit/' + row.id,
                query: { id: row.id }
            })
        },

        handleChange(row,key){
            this.reloadMap(row.id);
        },
        async reloadMap(id){
            const { data } = await getParking(id);
            this.form = data;
            this.form.type = this.form.type.toString();
            this.polygon.path = data.parking_fence; // 骑行区域渲染
            this.center = JSON.parse(data.parking_centre);

            this.polygons = [];
            this.parkings.forEach((item, i) => {
                if (this.form.id != item.id) {
                    this.polygons.push({
                        draggable: false,
                        strokeOpacity: 0.1,
                        fillOpacity: 0.5,
                        fillColor: 'green',
                        strokeColor: 'green',
                        strokeStyle: 'dashed',
                        path: item.parking_fence,
                    })
                }
            });
        },
        async getParing(id) {
            let polygons_data  = await getParkings({ type: 3, area_id: this.form.area_id });
            this.parkings = polygons_data.data;
            this.reloadMap(id);
        },
        onSearchResult(pois) {
            let latSum = 0;
            let lngSum = 0;
            if (pois.length > 0) {
                pois.forEach((poi) => {
                    let { lng, lat } = poi;
                    lngSum += lng;
                    latSum += lat;
                    this.markers.push([poi.lng, poi.lat]);
                });
                let center = {
                    lng: lngSum / pois.length,
                    lat: latSum / pois.length,
                };
                this.center = [center.lng, center.lat];
            }
        },
        async onSubmit() {
            this.form.parking_fence = [];
            let pos = []
            this.polygon.path.forEach(item => {
                var im = {lat: item.lat, lng: item.lng}
                pos.push(im)
            })
            this.form.parking_fence = pos;
            await updateParkingFence(this.form);
            this.$message.success("保存成功");
            this.getParing(this.form.id)
        },
    
    },
};
</script>
<style lang="scss" scoped>
.amap-page-container {
    width: 75%;
    position: relative;
    // height: 100%;
    top: -30px;
}

.amap-demo {
    /*height: 88%;*/
}

.info {
    border-radius: 0.25rem;
    position: absolute;
    top: 70px;
    width: auto;
    border-width: 0;
    right: 20px;
}

.search-box {
    height: 36px;
    border-radius: 0.25rem;
    top: 65px;
    border-width: 1px;
    left: 90px;
}

.form-class {
    width: 25%;
    overflow: auto;
}

.gary{
    background-color: #409EFF;
    color: #fff;
}
</style>
